import React from 'react';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import SyncIcon from '@material-ui/icons/SyncOutlined';
import CheckIcon from '@material-ui/icons/CheckCircleOutlined';
import { withStyles } from '@material-ui/core/styles';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Button from '../Button';
import useDebounce from 'react-use/lib/useDebounce';
import { Card } from '@material-ui/core';
import { useMutation } from 'react-apollo-hooks';
import { UPDATE_PPR_PLAN } from '../../common/graphql/UpdatePprPlan';
import classNames from 'classnames';

const styles = theme => ({
  root: {
    marginTop: 50,
    display: 'grid',
    gridRowGap: '10px',
  },
  text: {
    wordBreak: 'break-word',
  },
  indicator: {
    paddingTop: 5,
  },
  saved: {
    color: 'green',
  },
  syncing: {
    color: 'rgb(251, 192, 45)',
  },
  card: {
    marginTop: 10,
    boxShadow: 'none',
    background: '#eaeaea',
    cursor: 'text',
    borderRadius: 5,
    padding: 15,
    minHeight: '100px',
  },
  action: {
    justifySelf: 'end',
  },
  clickAwayGroup: {
    display: 'grid',
    gridRowGap: '10px',
  },
});

const MyPlan = ({ classes, plan: pprPlan, updatePprPlan, pprId: id }) => {
  const [plan, setPlan] = React.useState('');
  const [saved, setSaved] = React.useState(true);
  const [edit, setEdit] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [firstLoad, setFirstLoad] = React.useState(true);

  const updatePlan = async () => {
    setLoading(true);
    if (plan) {
      console.log('plan updating');
      try {
        const res = await updatePprPlan({ variables: { id, plan } });
        console.log('SUCCESS!!!!! ', res);
      } catch (e) {
        console.log('FAIL!! ', e);
      } finally {
        setSaved(true);
        setLoading(false);
        setEdit(false);
      }
    } else {
      console.log('plan NOT updating');
    }
  };

  useDebounce(
    () => {
      if (!firstLoad) {
        // updatePlan();
      } else {
        setFirstLoad(false);
      }
    },
    700,
    [plan],
  );
  React.useEffect(() => {
    console.log('mounted');
  }, []);
  React.useEffect(() => {
    if (pprPlan) {
      setPlan(pprPlan);
    }
  }, [pprPlan]);

  const handleClickAway = () => {
    if (plan) {
      setEdit(false);
    }
  };

  const handleChange = e => {
    setSaved(false);
    setPlan(e.target.value);
  };

  return (
    <div className={classes.root}>
      <Typography variant="h5">
        My Plan
        {saved ? (
          <CheckIcon
            className={classNames(classes.indicator, classes.saved)}
            fontSize="small"
          />
        ) : (
          <SyncIcon
            className={classNames(classes.indicator, classes.syncing)}
            fontSize="small"
          />
        )}{' '}
      </Typography>
      {edit ? (
        <>
          <ClickAwayListener onClickAway={handleClickAway}>
            <div className={classes.clickAwayGroup}>
              <TextField
                autoFocus
                fullWidth
                placeholder="Add a plan"
                value={plan}
                onChange={handleChange}
                multiline
                variant="outlined"
                rows={4}
              />
              <Button
                classes={{ root: classes.action }}
                color="primary"
                disabled={loading}
                onClick={updatePlan}
              >
                Save
              </Button>
            </div>
          </ClickAwayListener>
        </>
      ) : (
        <Card className={classes.card} onClick={() => setEdit(true)}>
          <Typography paragraph>{plan}</Typography>
        </Card>
      )}
    </div>
  );
};

export default withStyles(styles)(MyPlan);
